import { useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations, testimonials } from '../data/translations';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import PackagesSection from '../components/PackagesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  const { t } = useLanguage();
  const contactRef = useRef(null);
  const [selectedPackage, setSelectedPackage] = useState('');

  const scrollToContact = (packageName = '') => {
    setSelectedPackage(packageName);
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="landing-page">
      <Header scrollToContact={scrollToContact} />
      <main>
        <HeroSection scrollToContact={scrollToContact} />
        <ServicesSection />
        <PackagesSection scrollToContact={scrollToContact} />
        <TestimonialsSection />
        <div ref={contactRef}>
          <ContactSection selectedPackage={selectedPackage} setSelectedPackage={setSelectedPackage} />
        </div>
      </main>
      <Footer scrollToContact={scrollToContact} />
    </div>
  );
};

export default LandingPage;
